import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { Label } from '@hydra/common/components';
import { SeverityLevel } from '@hydra/routes/crawler/utils/parseSeverity';

const useStyles = makeStyles(theme => ({
  base: {
    justifyContent: 'center',
    fontWeight: theme.typography.fontWeightSemibold,
    [(theme.breakpoints.up('sm'))]: {
      justifyContent: 'flex-start'
    }
  }
}));

export interface IssueLabelProps {
  severity?: SeverityLevel,
  children?: React.ReactNode
}

export default function IssueLabel ({ severity = 'primary', children }: IssueLabelProps) {
  const classes = useStyles();
  return (
    <Label className={classes.base} style={severity} noBackground>
      {children}
    </Label>
  );
}
